export default __webpack_public_path__ + "static/media/Group 1830.ddac708c.png";